import { DEVICE_TYPE_SOURCE, DeviceTypesProvider, fetchDeviceTypesFromAOM } from 'core/contexts/device-types';
import { SettingsOperatorCustomNotificationFormContainer } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form';

const SettingsOperatorCustomNotificationFormScene: React.FC = () => (
    <DeviceTypesProvider fetchStrategy={fetchDeviceTypesFromAOM} source={DEVICE_TYPE_SOURCE.AOM}>
        <SettingsOperatorCustomNotificationFormContainer />
    </DeviceTypesProvider>
);

export default SettingsOperatorCustomNotificationFormScene;
